export const UploadQueueEvent = {
  FileStatusChanged: 'fileStatusChanged',
  QueueChanged: 'queueChanged',
  UploadQueueStarted: 'uploadQueueStarted',
  UploadQueueFinished: 'uploadQueueFinished'
};